import { render } from "./PasportIssuerSelect.vue?vue&type=template&id=089d3814&scoped=true"
import script from "./PasportIssuerSelect.vue?vue&type=script&lang=js"
export * from "./PasportIssuerSelect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./PasportIssuerSelect.vue?vue&type=style&index=1&id=089d3814&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089d3814"]])

export default __exports__